var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass:
        "text-base py-1 px-4 rounded-full font-400 flex items-center",
      class:
        _vm.variant === "green"
          ? "bg-badgeGreen text-skillGreen"
          : _vm.variant === "blue"
          ? "bg-lightBlue text-badgeBlue"
          : "bg-snow-white text-storm-gray",
    },
    [
      !!_vm.chipData && !!_vm.chipData.name
        ? _c(
            "span",
            {
              staticClass: "-mt-0.5",
              class: _vm.wrapChip
                ? "whitespace-pre-line"
                : "whitespace-no-wrap",
            },
            [_vm._v(_vm._s(_vm.chipData.name) + " ")]
          )
        : _vm._e(),
      !_vm.chipData || !_vm.chipData.name
        ? _c(
            "span",
            {
              staticClass: "-mt-0.5",
              class: _vm.wrapChip
                ? "whitespace-pre-line"
                : "whitespace-no-wrap",
            },
            [_vm._v(_vm._s(_vm.chipText) + " ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }